import {parsePhoneNumberFromString} from "libphonenumber-js";

const FormValidations = {
  validateTelephone: function (number: string | null | undefined): string | undefined {
    if (!number || number.trim() === "") return undefined;
    const phone = parsePhoneNumberFromString(number, "US");
    if (!phone || !phone.isValid()) {
      return "phone invalid";
    }
    return undefined;
  },

  convertInternationalIntoUSFormat: function (number: string | undefined): string | undefined {
    if (!number) return;
    const phone = parsePhoneNumberFromString(number, "US");
    return phone?.formatNational();
  },
};

export default FormValidations;
